import { Link } from "react-router-dom"
import "./news.css"
import image from "./adih.png"
export function OurApp() {
  return (
    <section className="our-app-section bg-white rounded-2xl ">
      <div className="our-app-container">
        {/* Image Section */}
        <div className="app-image-container">
          <img
            src={image}
            alt="Mobile App"
            className="app-image"
          />
          <div className="app-image-overlay"></div>
        </div>

        {/* Content Section */}
        <div className="app-content">
          <div className="app-text-content">
            <span className="app-subtitle">Download & Enjoy</span>
            <h2 className="app-title">Download the IndiaHirings.com Job Search App today</h2>
            <p className="app-description">
              Browse millions of jobs, find your perfect match, and
              apply with a simple swipe. Job hunting has never been
              this easy!
            </p>
          </div>

          {/* App Store Buttons */}
          <div className="app-store-buttons">
            <Link to="#" className="app-store-button google-play">
              <div className="button-content">
                <svg viewBox="0 0 24 24" className="button-icon">
                  <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
                </svg>
                <span className="button-text">
                  <span className="button-subtitle">GET IT ON</span>
                  <span className="button-title">Google Play</span>
                </span>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}